import React, { Component } from "react";
import { connect } from 'react-redux';
import { orderService } from 'services/order';
import {
	Grid,
	Row,
	Col,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Pagination from 'components/ThemeComponents/Pagination';
import { dateFormatMy } from 'helper/helperFunctions';
import { Link } from 'react-router-dom';
import { ThemeFunctions as TF } from 'helper/ThemeFunctions';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
const queryString = require('query-string');

class OrdersContactListSearchBy extends Component {
	constructor(props) {
		super(props);
		const parsed = queryString.parse(window.location.search);

		this.state = {
			queryString: parsed.code ? parsed.code : '',
			queryValue: parsed.value ? parsed.value : '',
			filtered: '',
			typingTimeout: 0
		}
	}

	paginationCall = (data) => {
		const updatedData = {
			...data,
			filter: this.state.filtered
		};
		const { queryString, queryValue } = this.state;
		return orderService.getOrdersSearchByContactList({ ...updatedData, queryString: queryString, queryValue: queryValue }).then(response => {
			return response;
		});
	}

	filterSearchHandle = (e) => {
		this.setState({
			'filtered': e.target.value
		});

		if (this.state.typingTimeout) {
			clearTimeout(this.state.typingTimeout);
		}

		this.setState({
			typingTimeout: setTimeout(() => {
				this.pagination.dataCall();
			}, 2000)
		});
	}

	render() {
		const { queryString } = this.state;
		var temp = '';
		if (queryString === 'groupName')
			temp = 'with same group name';
		else if (queryString === 'groupLeaderName')
			temp = 'with same group leader name';
		else if (queryString === 'groupLeaderEmail')
			temp = 'with same group leader email';
		else if (queryString === 'orderIds')
			temp = 'with same group name, group leader name and email';

		const columns = [
			{
				Header: "Orders Listing",
				headerClassName: 'headerPagination',
				columns: [
					{
						Header: "Barcode",
						accessor: "barcode",
                        width: 200,
						className: "action-center",
						Cell: ({ value, original }) => {
							return <Link target="_blank" to={'/Admin/' + original.id + '/order-edit'} className="blue_link">{value}</Link>
						},
						sortable: false,
					},
					{
						Header: "Group Name",
						accessor: "group_name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Contact Name",
						accessor: "group_leader_contact",
						Cell: ({ value }) => (
							<div>
								{
									value.last_name ? value.first_name.concat(value.last_name) : value.first_name
								}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Contact Email",
						accessor: "group_leader_contact",
						Cell: ({ value }) => (
							<div>
								{
									value.email
								}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Departure Date",
						accessor: "orderDates",
						className: "action-center",

						Cell: ({ value }) => (
							<div>
								{
									dateFormatMy(value.departure_date.value)
								}
							</div>
						),
						sortable: false,
					},
					{
						Header: "Destinations",
						accessor: "destinationsText",
						className: "action-center",
						sortable: false,
					},

                    {
                        Header: "Number of Uploaded Photos",
                        accessor: "originalImages",
                        className: "action-center",
						sortable: false,
                    },
					// {
					// 	Header: "Program Title",
					// 	accessor: "programtype",
					// 	Cell: ({ value }) => (
					// 		<div>
					// 			{
                    //                 value ?
					// 				value.title + '@' + value.price
                    //                 : null
					// 			}
					// 		</div>
					// 	),
					// 	className: "action-center",
					// 	sortable: false,
					// },
					{
						Header: "Travelers/At Home",
						accessor: "going_on_trip_count",
						className: "action-center",
						sortable: false,
						width: 185,
						Cell: ({ original }) => (
							<div>
								<span>{original.going_on_trip_count + "/" + original.following_from_home_count}</span>
							</div>
						),
					},
					{
						Header: "Production Status",
						accessor: "id",
						Cell: ({ row, original }) => (
							<div>
								{
									TF.productionStatus(row._original.orderSettings, row._original.status, row._original.csr_steps, row._original.on_hold_last_comment && row._original.on_hold_last_comment, row._original.cancel_last_comment && row._original.cancel_last_comment, row._original.orderDates, row._original.shippingDetails, 'left')

								}
							</div>
						),
						className: "action-center",
						sortable: false,
					},
				]
			}
		];
		return (
			<div className="content">
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<Row>
												<Col md={12}>
													<div className="secHeading">{`Orders list ${temp}`}</div>
												</Col>


												<Pagination
													ref={(p) => this.pagination = p}
													// showPagination={false}
													columns={columns}
													pageSize={50}
													getDataCall={this.paginationCall}
													filterView={false}
													// filterPlaceHolder={'users'}
													// downloadData={true}
													// downloadFileName={'Orders'}
													// lowerContent = {null}
													// filterPlaceHolder = {'Orders'}
													noDataText='No orders found'
													upperContent={
														<Grid fluid>
														  <div className="flexElem flexResponsive" style={{ "justifyContent": 'space-between' }}>
															<div className="custom-search-input" >
															  <FormInputs
																ncols={["col-md-12"]}
																onChange={this.filterSearchHandle}
																proprieties={[
																  {
																	type: "text",
																	bsClass: "form-control",
																	placeholder: "Search Orders",
																	onChange: this.filterSearchHandle,
																	name: "filter"
																  }
																]}
															  />
															</div>
														  </div>
														</Grid>
													  }
												// getRowProps={this.getRowProps}
												// showAllToggle={true}
												/>
											</Row>
										</Grid>


									</div>
								} />
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		// getOrdersSearchByContactListCall: (data, queryString) => { dispatch(getOrdersSearchByContactList(data, queryString)) },//example function
	});
};

function mapStateToProps(state) {
	// const { exampleConstant } = state.exampleReducer;

	return {
		// exampleConstant
	};
}


export default OrdersContactListSearchBy = connect(mapStateToProps, mapDispatchToProps)(OrdersContactListSearchBy);
// export default Test;
